import { Platform } from '@angular/cdk/platform';
import { NativeDateAdapter } from '@angular/material/core';
import format from 'date-fns/format';

/**
 //  date adapter formatting material2 datepicker & calendar labels
 //  path of adapter copyed from default DateAdapter
 //  https://github.com/angular/components/blob/master/src/material/core/datetime/native-date-adapter.ts
 */

let SUPPORTS_INTL_API: boolean;

try {
  SUPPORTS_INTL_API = typeof Intl !== 'undefined';
} catch {
  SUPPORTS_INTL_API = false;
}

export class DatepickerFieldUtcAdapter extends NativeDateAdapter {
  private customFormat = 'dd.LL.yyyy';
  private readonly overridedClampDate: boolean;

  constructor(matDateLocale: string, platform: Platform) {
    super(matDateLocale);
    super.setLocale(matDateLocale);
    this.overridedClampDate = platform.TRIDENT || platform.EDGE;
  }

  setFormat(newFormat: string): void {
    this.customFormat = newFormat;
  }

  getFirstDayOfWeek(): number {
    return 1;
  }

  format(date: Date, displayFormat: Object): string {
    if (!this.isValid(date)) {
      throw Error('NativeDateAdapter: Cannot format invalid date.');
    }

    if (displayFormat === 'input') {
      return format(date, this.customFormat);
    }

    if (SUPPORTS_INTL_API) {
      // eslint-disable-next-line no-underscore-dangle
      if (this.overridedClampDate && (date.getFullYear() < 1 || date.getFullYear() > 9999)) {
        date = this.clone(date);
        date.setFullYear(Math.max(1, Math.min(9999, date.getFullYear())));
      }

      displayFormat = { ...displayFormat, timeZone: 'utc' };

      const dtf = new Intl.DateTimeFormat(this.locale, displayFormat);
      // eslint-disable-next-line no-underscore-dangle
      return DatepickerFieldUtcAdapter.stripDirectionalityCharacters(
        DatepickerFieldUtcAdapter.overridedFormat(dtf, date),
      );
    }

    return super.format(date, displayFormat);
  }

  private static stripDirectionalityCharacters(str: string): string {
    return str.replace(/[\u200e\u200f]/g, '');
  }

  // today(): Date {
  //   return this.calendarService.utcDateTime(new Date());
  // }

  private static overridedFormat(dtf: Intl.DateTimeFormat, date: Date): string {
    const newDate = new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds(),
      ),
    );

    return dtf.format(newDate);
  }
}

export function platformProviderFactory(): () => Platform {
  return () => new Platform({});
}

export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: { month: 'numeric', year: 'numeric', day: 'numeric' },
  },
  display: {
    dateInput: { month: 'numeric', year: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' },
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};
